document.addEventListener('DOMContentLoaded', function () {
	const reviewsSection = document.querySelector('.section.reviews');

	if (!reviewsSection) return;

	const loadMoreBtn = reviewsSection.querySelector('.reviews__load-more');
	const reviewsContainer = reviewsSection.querySelector('.reviews__main');
	const paginationNav = reviewsSection.querySelector('.reviews__nav'); // Изменено с .reviews__pagination
	const btnText = loadMoreBtn ? loadMoreBtn.querySelector('.btn__text') : null;
	const btnLoader = loadMoreBtn
		? loadMoreBtn.querySelector('.btn__loader')
		: null;

	if (!loadMoreBtn || !reviewsContainer || !paginationNav) return;

	const reviewsPerPage = parseInt(reviewsSection.dataset.reviewsPerPage) || 2;
	const totalReviews = parseInt(reviewsSection.dataset.totalReviews) || 0;
	const postId = reviewsSection.dataset.postId || getPostIdFromUrl();

	function getCurrentLanguage() {
		if (typeof pll_current_language !== 'undefined') {
			return pll_current_language();
		}

		const langAttr = reviewsSection.dataset.currentLang;
		if (langAttr) return langAttr;

		const bodyClasses = document.body.className.split(' ');
		const langClass = bodyClasses.find(cls => cls.startsWith('lang-'));
		if (langClass) {
			return langClass.replace('lang-', '');
		}

		return 'ru';
	}

	function getPostIdFromUrl() {
		const urlParams = new URLSearchParams(window.location.search);
		return (
			urlParams.get('post_id') ||
			(window.location.pathname.includes('/p/')
				? window.location.pathname.split('/p/')[1].split('/')[0]
				: null)
		);
	}

	loadMoreBtn.addEventListener('click', loadMoreReviews);

	// Функция обновления пагинации
	function updatePagination(currentPage, totalPages) {
		// Обновляем активный номер страницы
		const pageNumbers = paginationNav.querySelectorAll('.reviews__page-number');
		pageNumbers.forEach(page => {
			page.classList.remove('reviews__page-number--active');

			const pageNum = parseInt(page.dataset.page);
			if (pageNum === currentPage) {
				page.classList.add('reviews__page-number--active');
			}

			// Обновляем ссылку для каждого номера
			page.href =
				updateQueryString(window.location.href, 'reviews_page', pageNum) +
				'#reviews';
		});

		// Обновляем стрелочки
		updateNavArrows(currentPage, totalPages);
	}

	// Функция обновления состояния стрелочек
	function updateNavArrows(currentPage, totalPages) {
		// Стрелка "Назад"
		const prevArrow = paginationNav.querySelector('.reviews__nav-arrow--prev');
		if (prevArrow) {
			if (currentPage > 1) {
				// Если это span, превращаем в ссылку
				if (prevArrow.tagName === 'SPAN') {
					const newLink = document.createElement('a');
					newLink.className = 'reviews__nav-arrow reviews__nav-arrow--prev';
					newLink.href =
						updateQueryString(
							window.location.href,
							'reviews_page',
							currentPage - 1,
						) + '#reviews';
					newLink.setAttribute('data-page', currentPage - 1);

					// Добавляем атрибуты доступности в зависимости от языка
					const currentLang = getCurrentLanguage();
					const prevLabel =
						currentLang === 'en'
							? 'Previous page'
							: currentLang === 'kk'
								? 'Алдыңғы бет'
								: 'Предыдущая страница';
					newLink.setAttribute('aria-label', prevLabel);
					newLink.setAttribute('title', prevLabel);

					newLink.innerHTML = prevArrow.innerHTML;
					prevArrow.replaceWith(newLink);
				} else {
					// Обновляем существующую ссылку
					prevArrow.href =
						updateQueryString(
							window.location.href,
							'reviews_page',
							currentPage - 1,
						) + '#reviews';
					prevArrow.setAttribute('data-page', currentPage - 1);
					prevArrow.classList.remove('reviews__nav-arrow--disabled');
				}
			} else {
				// Если на первой странице, превращаем ссылку в span
				if (prevArrow.tagName === 'A') {
					const newSpan = document.createElement('span');
					newSpan.className =
						'reviews__nav-arrow reviews__nav-arrow--prev reviews__nav-arrow--disabled';
					newSpan.setAttribute('aria-hidden', 'true');
					newSpan.innerHTML = prevArrow.innerHTML;
					prevArrow.replaceWith(newSpan);
				}
			}
		}

		// Стрелка "Вперед"
		const nextArrow = paginationNav.querySelector('.reviews__nav-arrow--next');
		if (nextArrow) {
			if (currentPage < totalPages) {
				if (nextArrow.tagName === 'SPAN') {
					const newLink = document.createElement('a');
					newLink.className = 'reviews__nav-arrow reviews__nav-arrow--next';
					newLink.href =
						updateQueryString(
							window.location.href,
							'reviews_page',
							currentPage + 1,
						) + '#reviews';
					newLink.setAttribute('data-page', currentPage + 1);

					const currentLang = getCurrentLanguage();
					const nextLabel =
						currentLang === 'en'
							? 'Next page'
							: currentLang === 'kk'
								? 'Келесі бет'
								: 'Следующая страница';
					newLink.setAttribute('aria-label', nextLabel);
					newLink.setAttribute('title', nextLabel);

					newLink.innerHTML = nextArrow.innerHTML;
					nextArrow.replaceWith(newLink);
				} else {
					nextArrow.href =
						updateQueryString(
							window.location.href,
							'reviews_page',
							currentPage + 1,
						) + '#reviews';
					nextArrow.setAttribute('data-page', currentPage + 1);
					nextArrow.classList.remove('reviews__nav-arrow--disabled');
				}
			} else {
				if (nextArrow.tagName === 'A') {
					const newSpan = document.createElement('span');
					newSpan.className =
						'reviews__nav-arrow reviews__nav-arrow--next reviews__nav-arrow--disabled';
					newSpan.setAttribute('aria-hidden', 'true');
					newSpan.innerHTML = nextArrow.innerHTML;
					nextArrow.replaceWith(newSpan);
				}
			}
		}
	}

	async function loadMoreReviews() {
		const currentPage = parseInt(loadMoreBtn.dataset.page) || 1;

		if (btnText && btnLoader) {
			btnText.style.opacity = '0.5';
			btnLoader.style.display = 'block';
		}

		loadMoreBtn.disabled = true;

		try {
			const response = await fetch(reviews_vars.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'load_more_reviews',
					nonce: reviews_vars.nonce,
					page: currentPage,
					post_id: postId,
					reviews_per_page: reviewsPerPage,
					current_lang: getCurrentLanguage(),
				}),
			});

			const data = await response.json();

			if (data.success) {
				// Добавляем новые отзывы
				reviewsContainer.insertAdjacentHTML('beforeend', data.data.html);

				// Обновляем номер следующей страницы на кнопке
				if (data.data.next_page) {
					loadMoreBtn.dataset.page = data.data.next_page;
				} else {
					// Скрываем кнопку, если больше нет страниц
					loadMoreBtn.style.display = 'none';
				}

				// Обновляем пагинацию с новыми данными
				updatePagination(data.data.current_page, data.data.total_pages);

				// Обновляем data-атрибуты в секции
				reviewsSection.dataset.currentPage = data.data.current_page;
				reviewsSection.dataset.totalPages = data.data.total_pages;
				reviewsSection.dataset.totalReviews = data.data.total_reviews;

				// Плавная прокрутка к последнему загруженному отзыву
				const newCards = reviewsContainer.querySelectorAll('.reviews__card');

				if (newCards.length > 0) {
					const lastNewCard = newCards[newCards.length - reviewsPerPage];
					if (lastNewCard) {
						lastNewCard.scrollIntoView({
							behavior: 'smooth',
							block: 'nearest',
						});
					}
				}
			} else {
				console.error('Error loading reviews:', data.data);
				showError('Произошла ошибка при загрузке отзывов');
			}
		} catch (error) {
			console.error('Error:', error);
			showError('Ошибка сети. Проверьте соединение.');
		} finally {
			if (btnText && btnLoader) {
				btnText.style.opacity = '1';
				btnLoader.style.display = 'none';
			}

			loadMoreBtn.disabled = false;
		}
	}

	function updateQueryString(uri, key, value) {
		const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
		const separator = uri.includes('?') ? '&' : '?';

		if (uri.match(re)) {
			return uri.replace(re, `$1${key}=${value}$2`);
		}
		return `${uri}${separator}${key}=${value}`;
	}

	function showError(message) {
		const errorDiv = document.createElement('div');
		errorDiv.className = 'reviews__error';
		errorDiv.style.cssText = `
			padding: 15px;
			margin: 10px 0;
			background: #fee;
			border: 1px solid #fcc;
			border-radius: 4px;
			color: #c00;
			text-align: center;
		`;
		errorDiv.textContent = message;

		loadMoreBtn.parentNode.insertBefore(errorDiv, loadMoreBtn.nextSibling);
		setTimeout(() => errorDiv.remove(), 5000);
	}

	// Инициализация пагинации при загрузке страницы
	const initialPage = parseInt(reviewsSection.dataset.currentPage) || 1;
	
	const initialTotalPages = parseInt(reviewsSection.dataset.totalPages) || 1;
	updatePagination(initialPage, initialTotalPages);
});
